export default __webpack_public_path__ + "static/media/hospital.90c5d3cf.svg";